import { ExpandIcon } from '@/assets/svgs'
import { useHeaderInfoQuery } from '@/hooks'
import { Flex, Image } from '@chakra-ui/react'

export function VideoCall({ expand, setExpand }: any) {
  const { data, isLoading } = useHeaderInfoQuery()

  return (
    <Flex
      // maxW={['100%', null, null, w]}
      height="100%"
      borderTopRadius="26px"
      bg="white"
      boxShadow="2px 2px 18px -7px rgba(15, 15, 38, 0.15)"
      direction="column"
      cursor="pointer"
    >
      <Flex
        borderRadius="26px"
        align="center"
        justify="center"
        backgroundColor="#414141"
        flexDirection="column"
        height="100%"
        cursor="pointer"
      >
        {!isLoading && (
          // eslint-disable-next-line jsx-a11y/iframe-has-title
          <iframe
            srcDoc={`<html>
              <head>
                <script src='https://8x8.vc/vpaas-magic-cookie-c72b0ade439b4dadb483e7ca0e46941c/external_api.js' async></script>
                <style>html, body, #jaas-container { height: 100%; }</style>
                <script type="text/javascript">
                  window.onload = () => {
                    const api = new JitsiMeetExternalAPI("8x8.vc", {
                     roomName:"${data?.Room}",
                      parentNode: document.querySelector('#jaas-container'),
                      jwt: '${data?.Token}'
                     });
                  }
                </script>
              </head>
              <body><div id="jaas-container" /></body>
            </html>`}
            width="100%"
            height="100%"
          />
        )}
        <Image
          width="50px"
          height="auto"
          fontSize="30px"
          marginLeft={5}
          marginRight="2"
          cursor="pointer"
          borderRadius="50%"
          backgroundColor="#fff"
          padding="3"
          margin="3"
          onClick={() => {
            if (expand === 1) {
              setExpand(0)
            } else {
              setExpand(1)
            }
          }}
          src={ExpandIcon}
        />
      </Flex>
    </Flex>
  )
}
